<div class="w-full">
    <div class="flex flex-row align-items-center w-full xl:w-8">
        <app-switch-input
            id="showDeactivated"
            label="database.usersPage.showOutdatedUsers"
            [form]="form"
            class="w-18rem font-bold mr-3"
            [ngClass]="{'text-400': !showDeactivatedUsers }"
        ></app-switch-input>
        <app-switch-input
            id="allUsers"
            label="database.usersPage.allUsers"
            [form]="form"
            class="w-18rem font-bold mr-3"
        ></app-switch-input>
        @if (this.store2.globalGlobalStore.organizationStore.isSettingActive(OrganizationSettingTypeEnum.HEALTHCARE_SOCIAL_SETTINGS)()) {
            <div class="flex flex-row w-full">
                <app-select-input
                    id="selectedService"
                    [form]="form"
                    [staticOptions]="serviceOptions"
                    valueKey="id"
                    label="database.usersPage.selectService"
                    labelKey="name"
                    [showClear]="true"
                    [ngClass]="{
                        'w-8 mr-4': selectedService,
                        'w-full': !selectedService
                    }"
                    [autoDisplayFirst]="false"
                >
                    <ng-template #item let-data>
                        <div class="flex gap-small">
                            <div
                                class="stripe"
                                [style]="'background-color: ' + data.color + ';'">
                            </div>
                            <div class="flex-column gap-xx-small">
                                <div>
                                    {{ data.name }}
                                </div>
                                @if (data.description) {
                                    <div class="font-size-x-small text-secondary">
                                        {{ data.description }}
                                    </div>
                                }
                            </div>
                        </div>
                    </ng-template>

                    <ng-template #selectedItem let-data>
                        <div class="flex gap-small">
                            <div class="stripe" [style]="'background-color: ' + data.color + ';'"></div>
                            <div>{{ data.name }}</div>
                        </div>
                    </ng-template>
                </app-select-input>
                <!--            <span *ngIf="selectedService" class="w-full">TODO: pracoviště</span>-->
            </div>
        }
    </div>
    <div class="w-full xl:w-8 mt-4">
        <app-search-input
            id="searchedText"
            [form]="form"
            label="database.usersPage.searchUsers"
        ></app-search-input>
    </div>
</div>
